// Translation mappings for vocabulary words
export const translations = {
  activity: "活动",
  are: "是（be动词复数）",
  back: "回来，回到",
  backpack: "书包",
  basketball: "篮球",
  because: "因为",
  believe: "相信",
  bet: "打赌",
  black: "黑色的",
  bring: "带来",
  busy: "忙碌的",
  "can’t": "不能 （cannot的缩写）",
  cloud: "云",
  compare: "比较",
  cool: "酷的；棒的",
  "come on": "来吧、快点",
  cute: "可爱的",
  do: "做",
  "doesn't": "不（does not）",
  "don’t": "不要（do not的缩写）",
  dive: "潜水",
  "diving mask": "潜水面罩",
  drown: "淹死",
  each: "每个",
  else: "其他",
  everyone: "每个人",
  faster: "更快的",
  finally: "终于",
  fins: "脚蹼（复数）",
  find: "找到",
  first: "第一；首先",
  found: "找到了（find的过去式）",
  frog: "青蛙",
  fun: "有趣的",
  funny: "有趣的",
  "get ready": "准备好",
  gloomy: "阴沉的",
  go: "出发（此处指跑）",
  "good morning": "早上好",
  guess: "猜",
  hard: "努力地",
  happy: "开心的",
  hate: "讨厌",
  have: "拥有，经历",
  heard: "听说（hear的过去式）",
  help: "帮助",
  here: "这里",
  home: "家",
  hope: "希望",
  how: "怎样",
  happen: "发生",
  "I’ve got": "我有（I have got的缩写）",
  inside: "往里面",
  into: "进入 ... 里",
  interesting: "有趣的",
  just: "只是",
  kid: "小孩，小朋友",
  "kind of": "有点",
  learn: "学习",
  like: "像",
  "like (verb)": "喜欢",
  line: "队，线",
  lying: "说谎（lie的 -ing形式）",
  look: "看",
  lost: "输掉（lose的过去式）",
  love: "喜爱",
  laundry: "洗衣房",
  make: "做，形成",
  mark: "标记",
  math: "数学",
  meet: "见面，遇见",
  mice: "老鼠（mouse的复数）",
  new: "新的",
  now: "现在",
  "of course": "当然",
  okay: "好吧",
  "over there": "在那边",
  play: "玩；打（球)",
  plan: "计划",
  probably: "可能",
  problem: "问题",
  race: "比赛",
  rain: "雨",
  recess: "课间休息",
  really: "非常，真的",
  remind: "提醒",
  right: "对的",
  rotten: "烂的，糟糕的",
  said: "说了（say的过去式）",
  school: "学校",
  "second grader": "二年级学生",
  see: "看",
  set: "准备好",
  she: "她",
  so: "太；很",
  something: "某事、某物",
  sound: "听起来",
  south: "南",
  sports: "运动",
  stopwatch: "秒表",
  street: "街",
  straight: "直的",
  sure: "当然，确定",
  swim: "游泳",
  teacher: "老师",
  terrible: "糟糕的",
  "that’s": "那是（that is）",
  "the best": "最好的",
  "the worst": "最糟的",
  "there you are": "你们在这儿呀！",
  think: "认为",
  time: "时间",
  tomorrow: "明天",
  two: "两个",
  ugh: "唉（表示烦恼或不情愿）",
  use: "使用",
  wait: "等待",
  welcome: "欢迎",
  will: "将要",
  win: "赢得（win 的过去式：won）",
  won: "赢得（win的过去式）",
  white: "白色的",
  wow: "哇",
  work: "工作",
  "work hard": "努力地工作",
  "yoo-hoo": "喂！（口语化招呼声）",
  yay: "耶（表欢呼）",
  you: "你们",
  about: "关于",
  star: "星星；明星",
  movie: "电影",
  rock: "摇滚",
  too: "也",
  those: "那些",
  kind: "种类",
  sky: "天空",
  twinkle: "闪烁",
  little: "小的",
  talk: "说、谈论",
  "I’ll": "我将（I will 的缩写）",
  more: "更多",
  ooh: "哦（语气词，表惊叹）",
  ball: "球",
  hot: "热的",
  gas: "气体",
  "the sun": "太阳",
  anything: "任何事情",
  bar: "柱子",
  car: "小汽车",
  jar: "罐子",
  true: "没错（语气词）",
  fact: "事实",
  give: "给",
  someone: "某人",
  chance: "机会",
  sorry: "对不起",
  down: "下",
  already: "已经",
  dizzy: "头晕",
  shh: "嘘（拟声词）",
  space: "太空",
  museum: "博物馆",
  watch: "观看",
  show: "表演，秀",
  huge: "巨大",
  globe: "球体",
  "here’s": "这是（here is 的缩写）",
  permission: "许可",
  slip: "纸条",
  team: "队伍",
  mine: "我的",
  yours: "你的",
  fill: "填满",
  fear: "恐惧",
  anywhere: "任何地方",
  without: "没有...",
  rule: "规则",
  stay: "留下",
  principal: "校长",
  office: "办公室",
  when: "当",
  book: "书",
  homework: "作业",
  "Mr.": "先生（Mister 的缩写）",
  lost: "丢了（lose 的过去式）",
  "couldn’t": "不能，没能（could not 的缩写）",
  favorite: "最喜欢的",
  planet: "行星",
  stuck: "被困住，被卡住",
  idea: "主意",
  take: "取／拿",
  ceiling: "天花板",
  shape: "做成…的形状",
  "supposed to": "应该",
  "look like": "看起来像",
  whoa: "哇（语气词，表惊叹）",
  "the Milky Way": "银河，银河系",
  Saturn: "土星",
  poor: "可怜的",
  bored: "（感到）无聊的",
  helper: "帮手、助手",
  job: "工作，任务",
  fix: "修理",
  slide: "滑梯",
  playground: "学校的游乐区域",
  tighten: "拧紧",
  bolt: "螺栓",
  dog: "狗",
  next: "下一个",
  sweep: "打扫",
  art: "艺术",
  floor: "（室内的）地、地板",
  visit: "参观、拜访",
  kindergarten: "幼儿园",
  would: "会（表虚拟）",
  if: "假如",
  red: "红色",
  Mars: "火星",
  call: "称呼",
  pink: "粉色",
  color: "颜色",
  "gift shop": "礼品商店",
  brought: "带来了（bring 的过去式）",
  money: "钱",
  buy: "买",
  last: "最后",
  clean: "清洁",
  window: "窗户",
  odd: "奇怪的",
  light: "灯",
  off: "关着",
  amazing: "令人惊奇的",
  relax: "放松",
  under: "在…下面",
  anyone: "任何人",
  awesome: "太棒了",
  "the Big Dipper": "北斗七星",
  from: "从",
  boring: "无聊的",
  "get to": "有机会；得以",
};

export function getTranslation(word) {
  const translation = translations[word.toLowerCase()];
  return {
    chinese: translation || null,
    pinyin: null,
  };
}
